import React from 'react';
import './Refund.css'; // Optional: for styling

const Refund: React.FC = () => {
  return (
    <div className='refund-container'>
      <h1>Service Cancellation & Refund Policy</h1>
      <p>
        We understand that plans can change. Please review our cancellation and refund policy below:
      </p>

      <h2>Cancellation Requests:</h2>
      <ul>
        <li>
          <strong>72 Hours or More in Advance:</strong> Cancellations made{' '}
          <strong>72 hours or more</strong> before the scheduled service date are eligible for a{' '}
          <strong>full refund</strong>, minus any non-refundable third-party fees already incurred
          on your behalf.
        </li>
        <li>
          <strong>Within 72 Hours:</strong> Cancellations made <strong>within 72 hours</strong> of
          the scheduled service date may be eligible for a{' '}
          <strong>partial refund of up to 50%</strong>, excluding any non-refundable third-party
          costs.
        </li>
        <li>
          <strong>Same-Day or No-Shows:</strong> Cancellations on the day of service or failure to
          appear (no-shows) are <strong>not eligible for a refund</strong>. Refunds will not be
          provided for any unused services once your experience has begun.
        </li>
      </ul>

      <h2>How to Cancel:</h2>
      <p>
        All cancellation requests must be submitted in writing to{' '}
        <a href='mailto:support@saef.app'>support@saef.app</a>. Refunds, if applicable, will be
        processed within <strong>7–10 business days</strong> to your original payment method.
      </p>

      <p>
        We appreciate your understanding and look forward to making your Vegas experience
        exceptional.
      </p>
    </div>
  );
};

export default Refund;
